import PropTypes from 'prop-types';
import { useMemo } from 'react';
import styles from './CustomRater.module.scss';

export const getClass = (rating, index) => {
	const left = rating - index;
	return left >= 0 ? 'is-active' : left > -1 ? 'is-half-active' : 'is-inactive';
};

const CustomRater = ({ rating = 0, maxRating = 5, customClass }) => {
	const children = useMemo(() => {
		const arr = [];
		const computedClass = [styles.star, customClass].filter(Boolean).join(' ');

		for (let i = 0; i < maxRating; i++) {
			arr.push(
				<div key={i} className={`${styles[getClass(rating, i + 1)]} ${computedClass}`} data-test-id="rater-star">
					★
				</div>,
			);
		}
		return arr;
	}, [rating, maxRating]);

	return (
		<div className={`${styles['custom-rater']}`} data-test-id="rater">
			{children}
		</div>
	);
};

CustomRater.propTypes = {
	rating: PropTypes.number,
	maxRating: PropTypes.number,
	customClass: PropTypes.string,
};

export default CustomRater;
